// eslint-disable-next-line eag/no-external-date-time-format-functions -- Intended to use here
import {format, formatDistanceToNowStrict} from 'date-fns';
import {match} from 'ts-pattern';

import {curry} from 'ramda';

import {AppLanguage} from '../../../types/AppLanguage';
import {LocaleConfig} from '../../../types/LocaleConfig';
import {LocaleDateTimeFormat} from '../../../types/LocaleDateTimeFormat';
import {convertStringLocaleToDateFns} from '../../../utils/convertStringLocaleToDateFns';

function uncurriedFormatDateTime(
  localeConfig: LocaleConfig,
  language: AppLanguage,
  dateTimeFormat: LocaleDateTimeFormat,
  value: Date
) {
  return match(dateTimeFormat)
    .with('dateRelative', () =>
      formatDistanceToNowStrict(value, {
        addSuffix: true,
        locale: convertStringLocaleToDateFns(language),
      })
    )
    .otherwise((formatKey) =>
      format(value, localeConfig.dateTimeFormat[formatKey], {
        locale: convertStringLocaleToDateFns(language),
      })
    );
}

export const formatDateTime = curry(uncurriedFormatDateTime);
